export default "__VITE_ASSET__DExcoJCp__"